import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import warning from 'warning';
import apiClient from '@rexlabs/api-client';
import { printWingsError } from './wings-utils';
import { partial } from 'lodash';
var ERRORS = {
  CLIENT_ERROR: apiClient.CLIENT_ERROR,
  SERVER_ERROR: apiClient.SERVER_ERROR,
  CANCEL_ERROR: apiClient.CANCEL_ERROR,
  TIMEOUT_ERROR: apiClient.TIMEOUT_ERROR,
  CONNECTION_ERROR: apiClient.CONNECTION_ERROR,
  NETWORK_ERROR: apiClient.NETWORK_ERROR,
  UNKNOWN_ERROR: apiClient.UNKNOWN_ERROR
};
var DEFAULT_WINGS_ARGS = {
  use_status_codes: true,
  use_strict_arguments: true,
  strip_response_prefixes: true
};

function parseWingsResponse(url, service, args, stack, shouldLogNiceErrors, response) {
  // Catch empty responses here
  if (!response || !response.hasOwnProperty('data')) {
    console.warn('Empty wings response', response, service, args, stack);
    return;
  } // Otherwise handle response data


  var data = response.data;
  if (response.ok) return data.result;else {
    var error; // expect {type, message, code}

    switch (response.problem) {
      case ERRORS.CLIENT_ERROR:
      case ERRORS.SERVER_ERROR:
        if (shouldLogNiceErrors) {
          warning(data.error != null, 'API errors are expected to always return an \'error\' property.');
          printWingsError(url, service, args, data, data.error, stack);
        }

        error = data.error;
        break;

      case ERRORS.CONNECTION_ERROR:
      case ERRORS.NETWORK_ERROR:
      case ERRORS.TIMEOUT_ERROR:
        error = {
          type: 'NetworkError',
          message: 'There seems to be a problem with your network. Please try again soon.',
          code: null
        };
        break;

      case ERRORS.CANCEL_ERROR:
        // Cancelled request shouldn't trigger promise listeners of the Wings client
        return new _Promise(function () {});

      case ERRORS.UNKNOWN_ERROR:
      default:
        error = {
          type: 'Unknown Error',
          message: 'An unknown error occured on the client. Please contact support.',
          code: null
        };
        break;
    }

    if (error) {
      var err = new Error(error.message, error.code);
      err.type = error.type;
      err.extra = error.extra;
      throw err;
    }
  }
}

function wingsRequest(client, token, method, args, config, shouldLogNiceErrors, defaultOverrides) {
  var stack = new Error().stack;

  var data = _Object$assign({}, DEFAULT_WINGS_ARGS, _objectSpread({
    method: method,
    token: token,
    args: args
  }, defaultOverrides));

  return client.post('', data, config).then(partial(parseWingsResponse, client.axiosInstance.defaults.baseURL, method, args, stack, shouldLogNiceErrors));
}
/**
 * Creates a Wings API client.
 * wings('Service::method', {...args}, axiosConfig)
 *
 * Sub methods also exist, based on the api-client package.
 *
 * `get`, `head`, `delete`, `link` and `unlink` accept 3 parameters:
 *   - url - the relative path to the API (required)
 *   - params - Object - query string variables (optional)
 *   - axiosConfig - Object - config passed along to the `axios` request (optional)

 * `post`, `put`, and `patch` accept 3 different parameters:
 *   - url - the relative path to the API (required)
 *   - data - Object - the object jumping the wire
 *   - axiosConfig - Object - config passed along to the `axios` request (optional)
 *
 * @param {Object|String} config - The config object for @rexlabs/api-client.
 *        Should atleast have a baseURL field. Can also just be the baseURL string instead of a config object.
 * @param {Boolean} [shouldLogNiceErrors=true] - Whether to log errors nicely; suitable for web.
 * @param {Object} defaultOverrides - Used to override the default wings args that are passed on every request.
 * @return {function (String, Object, Object)} The new Wings API client
 */


export function createWingsClient(config) {
  var shouldLogNiceErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultOverrides = arguments.length > 2 ? arguments[2] : undefined;
  var storedToken;

  if (typeof config === 'string') {
    config = {
      baseURL: config
    };
  }

  if (!config.baseURL) {
    throw new Error('Missing the baseURL field from the client config.');
  }

  var client = apiClient.create(_Object$assign({
    timeout: 15000
  }, config));

  var wingsClient = function wingsClient(service, args, config) {
    return wingsRequest(client, storedToken, service, args, config, shouldLogNiceErrors, defaultOverrides);
  };

  wingsClient.client = client;

  wingsClient.setAuthToken = function (token) {
    storedToken = token;
  };

  return wingsClient;
}